import { defineMessages } from 'react-intl';

const messages = defineMessages({
  newText: {
    id: 'HelpTags.NewText',
    defaultMessage: 'NEW',
  },
});

export default messages;
